export const NOMINATION = 'nomination';
